import { enqueueSnackbar } from "notistack";
import {
  FETCH_DOCUMENTS_FAILURE,
  FETCH_DOCUMENTS_REQUEST,
  FETCH_DOCUMENTS_SUCCESS,
} from "../constants";
import { getRequestAuthenticationRequest } from "../../../services/apiManager/apiRequests";
import apiConfig from "../../../services/apiManager/apiConfig";
import SnackbarConfig from "../../../utils/snackbarConfig";

export const fetchUploadedDocumentsRequest =
  (id, userProfile, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: FETCH_DOCUMENTS_REQUEST,
        payload: { isLoading: true },
      });
      const response = await getRequestAuthenticationRequest(
        userProfile === "OWNER"
          ? apiConfig.getDocumentsOwner + `${id}/getDocs`
          : apiConfig.getDocumentsOperator + `${id}/getDocs`,
        null,
      );
      if (response?.statuscode === 200) {
        dispatch({
          type: FETCH_DOCUMENTS_SUCCESS,
          payload: response?.data,
        });
        callback(response);
      } else {
        dispatch({
          type: FETCH_DOCUMENTS_FAILURE,
          payload: { isLoading: false },
        });
        callback({});
      }
    } catch (error) {
      callback({});
      if (error?.response?.data?.errMsg) {
        enqueueSnackbar(error?.response?.data?.errMsg, {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
      }
      dispatch({
        type: FETCH_DOCUMENTS_FAILURE,
        payload: { isLoading: false },
      });
    }
  };
